import React from 'react';
import Range from '../../Range';

interface InlinePageRangesProps {
    ranges: [RangeProps];
}

interface RangeProps {
    minLabel: string;
    maxLabel: string;
    value: number;
}

export default function InlinePageRanges({ ranges }: InlinePageRangesProps) {
    return (
        <div>
            {ranges.map((range, index) => {
                return (
                    <Range
                        minLabel={range.minLabel}
                        maxLabel={range.maxLabel}
                        min={-5}
                        max={5}
                        value={range.value}
                        key={index}
                    />
                );
            })}
        </div>
    );
}

InlinePageRanges.calculateMaxHeightPercentage = function (): number {
    return 0.6;
};
